module.exports = __webpack_public_path__ + "static/media/ic-mail-outline.c6e475d1.svg";